'use strict';

import controller from './datos-form.controller';
import template from './datos-form.html';

const DatosFormComponent = {
  bindings: {
    supervision: '<',
  },
  controller,
  template
};

export default DatosFormComponent;



// WEBPACK FOOTER //
// ./src/app/components/empresas/planilla-proyecto/datos-form246/datos-form.component.js